import { type FC } from 'react';
import { StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';
import Colors from 'src/core/utils/Colors';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';

interface Props {
	text: string;
	icon?: string | undefined;
	variant?: 'light' | 'dark';
	size?: 'default' | 'small';
	style?: StyleProp<ViewStyle>;
}

const CardLabel: FC<Props> = ({ text, icon: iconProp, variant = 'light', size = 'default', style }) => {
	const isDark = variant === 'dark';
	const isSmall = size === 'small';

	return (
		<View style={[styles.cardLabel, isDark && styles.cardLabelDark, isSmall && styles.cardLabelSmall, style]}>
			{iconProp && (
				<SvgIcon
					name={iconProp}
					size={isSmall ? Dimens.iconSize12 : Dimens.iconSize14}
					style={styles.cardLabelIcon}
					tintColor={isDark ? Colors.white : Colors.black}
				/>
			)}
			<Text style={[styles.cardLabelText, isDark && styles.cardLabelTextDark, isSmall && styles.cardLabelTextSmall]}>
				{text}
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	cardLabel: {
		backgroundColor: Colors.white,
		borderRadius: Dimens.borderRadius3,
		flexDirection: 'row',
		gap: Dimens.gap4,
		left: Dimens.padding20,
		marginRight: Dimens.padding20,
		maxWidth: Dimens.size300,
		paddingHorizontal: Dimens.padding8,
		paddingVertical: Dimens.padding4,
		position: 'absolute',
		shadowRadius: Dimens.size3,
		top: Dimens.padding20,
	},
	cardLabelDark: {
		backgroundColor: Colors.black99,
		shadowOpacity: Dimens.opacity0,
	},
	cardLabelSmall: {
		paddingHorizontal: Dimens.padding6,
		paddingVertical: Dimens.padding2,
	},
	cardLabelIcon: {
		marginTop: Dimens.padding3,
	},
	cardLabelText: {
		color: Colors.gray900,
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize12,
		lineHeight: Dimens.lineHeight21,
		textTransform: 'uppercase',
	},
	cardLabelTextDark: {
		color: Colors.white,
		fontFamily: Fonts.barlowMedium,
	},
	cardLabelTextSmall: {
		fontSize: Dimens.fontSize10,
	},
});

export default CardLabel;
